module.exports = __webpack_public_path__ + "static/enerjisa-case-study-2e8c8b6227ca8730407ee00f833b2378.webp";